import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/helpers/auth.service';
import { Utils } from 'src/app/helpers/utils';
import { SystemDesignService } from '../../system-design/system-design.service';

@Component({
  standalone: false,
  selector: 'app-trial-expired',
  templateUrl: './trial-expired.component.html',
  styleUrls: ['./trial-expired.component.scss'],
})
export class TrialExpiredComponent implements OnInit {
  trialEndDate = '';
  supportEmail = environment.supportEmail;
  username = '';
  showUserMenu = false;
  upgradeRequestLoading = false;
  upgradeRequestSent = false;
  logo = '/assets/images/login/enact-logo-new.jpg';

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private systemDesignService: SystemDesignService,
  ) {}

  ngOnInit(): void {
    const ts = localStorage.getItem('trial_expires_at');
    if (ts) {
      const date = new Date(parseInt(ts, 10));
      this.trialEndDate = date.toLocaleDateString(undefined, {
        year: 'numeric', month: 'long', day: 'numeric'
      });
    }
    this.username = this.authService.getItem('username') || '';
    this.loadLogo();
  }

  private loadLogo(): void {
    this.systemDesignService.getTenantData().subscribe(
      (response: { imageId: any }) => {
        if (response?.imageId) {
          this.systemDesignService.getLogo(response.imageId).subscribe(
            (data: string) => { this.logo = 'data:image/jpg;base64,' + data; },
            () => { this.logo = '/assets/images/login/enact-logo-sm.jpg'; }
          );
        }
      },
      () => { this.logo = '/assets/images/login/enact-logo-sm.jpg'; }
    );
  }

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
  }

  logout(): void {
    this.authService.logout();
  }

  requestUpgrade(): void {
    if (this.upgradeRequestSent || this.upgradeRequestLoading) return;
    const sessionId = this.authService.getItem('sessionId', 'localStorage');
    if (!sessionId) return;

    this.upgradeRequestLoading = true;
    const url = `${Utils.getBaseurl()}public/signup/request-upgrade?sessionId=${encodeURIComponent(sessionId)}`;
    this.http.post(url, null).subscribe({
      next: () => {
        this.upgradeRequestLoading = false;
        this.upgradeRequestSent = true;
      },
      error: () => {
        this.upgradeRequestLoading = false;
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.header-user')) {
      this.showUserMenu = false;
    }
  }
}
